import { useState, useEffect } from 'react';
import './Pagination.css';
import DoubleLeftIcon from '../../assets/icons/doubleLeft.svg?react';
import DoubleRightIcon from '../../assets/icons/doubleRight.svg?react';
import LeftIcon from '../../assets/icons/left.svg?react';
import RightIcon from '../../assets/icons/right.svg?react';
const Pagination = ({ 
  currentPage = 1, 
  totalPages = 1, 
  onPageChange,
  maxVisiblePages = 10,
  size = 'medium' // 'small', 'medium', 'large'
}) => {
  const [pageNumbers, setPageNumbers] = useState([]);
  const [startPage, setStartPage] = useState(1);

  // 페이지 번호 배열 생성
  useEffect(() => {
    const start = Math.floor((currentPage - 1) / maxVisiblePages) * maxVisiblePages + 1;
    const end = Math.min(start + maxVisiblePages - 1, totalPages);
    
    const numbers = [];
    for (let i = start; i <= end; i++) {
      numbers.push(i);
    }
    
    setPageNumbers(numbers);
    setStartPage(start);
  }, [currentPage, totalPages, maxVisiblePages]);

  // 이전 페이지 그룹으로 이동
  const handlePrevGroup = () => {
    const newStartPage = Math.max(1, startPage - maxVisiblePages);
    const newPage = newStartPage;
    onPageChange(newPage);
  };

  // 다음 페이지 그룹으로 이동
  const handleNextGroup = () => {
    const newStartPage = startPage + maxVisiblePages;
    if (newStartPage <= totalPages) {
      onPageChange(newStartPage);
    }
  };

  // 이전 페이지로 이동
  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  // 다음 페이지로 이동
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  // 특정 페이지로 이동
  const handlePageClick = (page) => {
    onPageChange(page);
  };

  // 페이지 그룹 정보 계산
  const currentGroup = Math.floor((currentPage - 1) / maxVisiblePages) + 1;
  const totalGroups = Math.ceil(totalPages / maxVisiblePages);

  // 페이지가 1개만 있어도 페이지네이션을 표시
  // if (totalPages <= 1) {
  //   return null;
  // }

  return (
    <div className={`pagination-container pagination-${size}`}>
      <div className="pagination-info">
        <span>페이지 {currentPage} / {totalPages}</span>
        {totalPages > 1 && <span>그룹 {currentGroup} / {totalGroups}</span>}
      </div>
      
      <div className="pagination-controls">
        {/* 이전 페이지 그룹 버튼 */}
        <button
          className={`pagination-btn pagination-group-btn ${startPage <= 1 ? 'disabled' : ''}`}
          onClick={handlePrevGroup}
          disabled={startPage <= 1}
          title="이전 페이지 그룹"
        >
          <DoubleLeftIcon color='var(--gray-700)'/>
        </button>

        {/* 이전 페이지 버튼 */}
        <button
          className={`pagination-btn pagination-prev-btn ${currentPage <= 1 ? 'disabled' : ''}`}
          onClick={handlePrevPage}
          disabled={currentPage <= 1}
          title="이전 페이지"
        >
          <LeftIcon color='var(--gray-700)'/>
        </button>

        {/* 페이지 번호들 */}
        <div className="page-numbers">
          {pageNumbers.map((page) => (
            <button
              key={page}
              className={`pagination-btn page-number ${currentPage === page ? 'active' : ''}`}
              onClick={() => handlePageClick(page)}
            >
              {page}
            </button>
          ))}
        </div>

        {/* 다음 페이지 버튼 */}
        <button
          className={`pagination-btn pagination-next-btn ${currentPage >= totalPages ? 'disabled' : ''}`}
          onClick={handleNextPage}
          disabled={currentPage >= totalPages}
          title="다음 페이지"
        >
          <RightIcon color='var(--gray-700)'/>
        </button>

        {/* 다음 페이지 그룹 버튼 */}
        <button
          className={`pagination-btn pagination-group-btn ${startPage + maxVisiblePages > totalPages ? 'disabled' : ''}`}
          onClick={handleNextGroup}
          disabled={startPage + maxVisiblePages > totalPages}
          title="다음 페이지 그룹"
        >
          <DoubleRightIcon color='var(--gray-700)'/>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
